import { Alert } from "antd";
import * as Sentry from "@sentry/react";

const ApErrorBoundary = process.env.REACT_APP_MODE === "production" ? Sentry.ErrorBoundary : Alert.ErrorBoundary;

export default ApErrorBoundary;